import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import AddressTypeService from "../../../Services/AddressType.service";
const makeSearchArgs = {
    loadOptions: (search, options) => AddressTypeService.search(Object.assign(Object.assign({}, options), { searchText: search })).then(({ data }) => data),
    label: "srcSystemName",
    value: "id",
};
export const AddressTypeSearch = makeSearch(makeSearchArgs);
export const AddressTypeMultiSearch = makeMultiSearch(Object.assign({}, makeSearchArgs));
